<template>
    <header class="search_banner--holder">
        <section class="search_banner">
            <h1 class="search_banner--title">よくあるご質問</h1>

            <v-card
                tile
                flat
                class="search_banner_input--card"
            >
                <v-combobox
                    v-model="select"
                    :items="questionsItems"
                    :loading="isLoading"
                    :search-input.sync="search"
                    :filter="filter"
                    color="#04b0e5"
                    flat
                    single-line
                    outlined
                    clearable
                    hide-details
                    placeholder="質問を検索"
                    prepend-inner-icon="mdi-magnify"
                    return-object
                    item-text="title"
                    class="search_banner_input"
                >
                    <!--                    <template slot="selection" slot-scope="data">-->
                    <!--                        {{ data.item.title }}-->
                    <!--                    </template>-->
                    <template slot="item" slot-scope="data">
                        <v-list-item-content @click="gotToRoute(data.item.id)">
                            <v-list-item-title v-html="data.item.title" />
                            <v-list-item-subtitle v-html="data.item.answer.replace(/(<([^>]+)>)/ig,'')" />
                        </v-list-item-content>
                    </template>
                </v-combobox>
            </v-card>
        </section>
    </header>
</template>

<script>
export default {
    name: 'SearchBanner',
    data: () => ({
        select: null,
        search: null,
        descriptionLimit: 60,
        isLoading: false,
        questionsItems: []
    }),
    computed: {
        allQuestions () {
            return this.$store.getters.getQuestions
        }
    },
    created () {
        this.questionsItems = this.allQuestions
    },
    methods: {
        filter (item, queryText) {
            console.log(item.title)
            console.log(queryText)
            console.log('title', item.title.toLowerCase().includes(queryText.toLowerCase()))
            console.log('answer', item.answer.toLowerCase().includes(queryText.toLowerCase()))
            return (item.title.toLowerCase().includes(queryText.toLowerCase()) || item.answer.toLowerCase().includes(queryText.toLowerCase()))
        },

        gotToRoute (id) {
            this.select = null
            this.search = null
            this.$router.push({ name: 'id', params: { id } })
        },

        querySelections (v) {
            this.loading = true
            // Simulated ajax query
            this.questionsItems = this.allQuestions.filter((e) => {
                return (e.answer || '').toLowerCase().includes((v || '').toLowerCase()) > -1
            })
            this.loading = false
        }
    }
}
</script>
